module.exports = __webpack_public_path__ + "images/ExternalPromo/weebly-378910-160_600.gif?f0496";